import { useMemo } from 'react';

import type { CylanceConsole } from '@rtkwlf/eloc';
import { stringify } from 'query-string';

import { useFeatureFlag } from '@packages/platform/feature-flags';

export const useCylanceConsoleLinks = (
  cylanceConsole: CylanceConsole[] | undefined,
  idToken: string | undefined,
) => {
  const [cylanceConsoleFF] = useFeatureFlag('CYLANCE_CONSOLE_LINKS');

  return useMemo(() => {
    if (!cylanceConsoleFF || !cylanceConsole) return [];

    return cylanceConsole.map(({ name, tenantId, portalUrl }) => {
      const queryParams = stringify({
        id_token_hint: idToken,
        tenant: tenantId,
      });

      return {
        text: name,
        href: [`${portalUrl}/uc/session/sso-login`, queryParams].join('?'),
      };
    });
  }, [cylanceConsole, cylanceConsoleFF, idToken]);
};
